<ish-content-design-view-wrapper [slotId]="slot" [pagelet]="pagelet">
  <ng-content *ngIf="wrapper; else renderPagelets"></ng-content>

  <ng-template #renderPagelets>
    <ish-content-pagelet *ngFor="let pagelet of pagelet.slot(slot).pageletIDs" [pageletId]="pagelet" />
  </ng-template>
</ish-content-design-view-wrapper>
